import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { ArtistPostProfileWorkHistoryStatusParams } from './request';
import { artistPostProfileWorkHistoryStatus } from './request';

export const useArtistProfileWorkHistoryStatusMutation = (
  settings?: MutationSettings<
    ArtistPostProfileWorkHistoryStatusParams,
    typeof artistPostProfileWorkHistoryStatus
  >
) =>
  useMutation({
    mutationKey: ['ArtistProfileWorkHistory'],
    mutationFn: ({ params, config }) =>
      artistPostProfileWorkHistoryStatus({
        params,
        config
      }),
    ...settings?.options
  });
